import { Modal, TextInput, NumberInput, Button, Stack } from '@mantine/core'
import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { servicesApi } from '@/api'
import { notifications } from '@mantine/notifications'

interface CreateServiceModalProps {
  opened: boolean
  onClose: () => void
  onSuccess: () => void
}

export function CreateServiceModal({ opened, onClose, onSuccess }: CreateServiceModalProps) {
  const [name, setName] = useState('')
  const [image, setImage] = useState('')
  const [replicas, setReplicas] = useState(1)

  const createMutation = useMutation({
    mutationFn: async () => {
      const { data } = await servicesApi.create({
        Name: name,
        TaskTemplate: {
          ContainerSpec: {
            Image: image,
          },
        },
        Mode: {
          Replicated: {
            Replicas: replicas,
          },
        },
      })
      return data
    },
    onSuccess: () => {
      notifications.show({
        title: 'Service created',
        message: `Service ${name} has been created successfully`,
        color: 'green',
      })
      onSuccess()
      resetForm()
    },
    onError: () => {
      notifications.show({
        title: 'Error',
        message: 'Failed to create service',
        color: 'red',
      })
    },
  })

  const resetForm = () => {
    setName('')
    setImage('')
    setReplicas(1)
  }

  const handleSubmit = () => {
    if (!name || !image) {
      notifications.show({
        title: 'Validation error',
        message: 'Please fill in all required fields',
        color: 'red',
      })
      return
    }
    createMutation.mutate()
  }

  return (
    <Modal opened={opened} onClose={onClose} title="Create Service" size="md">
      <Stack>
        <TextInput
          label="Service Name"
          placeholder="my-service"
          value={name}
          onChange={(e) => setName(e.currentTarget.value)}
          required
        />
        
        <TextInput
          label="Image"
          placeholder="nginx:latest"
          value={image}
          onChange={(e) => setImage(e.currentTarget.value)}
          required
        />
        
        <NumberInput
          label="Replicas"
          min={1}
          value={replicas}
          onChange={(value) => setReplicas(Number(value) || 1)}
        />
        
        <Button
          fullWidth
          onClick={handleSubmit}
          loading={createMutation.isPending}
        >
          Create Service
        </Button>
      </Stack>
    </Modal>
  )
}